import React from "react";

// Card Container
export const Card = ({
  children,
  className = "",
  padding = "p-6",
  ...props
}) => (
  <div
    className={`card-board ${padding} ${className}`}
    {...props}
  >
    {children}
  </div>
);

export default Card;
